/**
 * @param {object} Drupal - The Drupal object.
 * @param {object} Vimeo - The Vimeo Player library.
 */
(function (Drupal, Vimeo) {
  'use strict';

  Drupal.behaviors.mediaVideo = {
    attach: function (context, settings) {

      once('js-media-video', '[data-component-id="tnvacation:media-video"]', context).forEach(function (component) {
        const videoContainer = context.querySelector('.media-video__container');
        const wrapperMessage = component.querySelector('.video-wrapper-message');
        const isChromium = /\b(?:Chrome|Chromium)\//.test(window.navigator.userAgent)
          && !/\b(?:Edg|OPR)\//.test(window.navigator.userAgent);

        // Chromium + VoiceOver announces the span text as a group.
        if (isChromium && wrapperMessage) {
          wrapperMessage.setAttribute('aria-label', wrapperMessage.textContent.trim());
          wrapperMessage.textContent = '';
        }

        if (!videoContainer) {
          return;
        }

        const video = videoContainer.querySelector('iframe');

        if (!video) {
          return;
        }

        // Chromium + VoiceOver needs the iframe exposed before Tab enters it.
        if (isChromium) {
          if (wrapperMessage) {
            wrapperMessage.addEventListener('focus', () => {
              videoContainer.setAttribute('aria-hidden', 'true');
            });

            wrapperMessage.addEventListener('keydown', (event) => {
              if (event.key === 'Tab' && !event.shiftKey) {
                videoContainer.removeAttribute('aria-hidden');
              }
            });
          }

          video.addEventListener('focus', () => {
            videoContainer.removeAttribute('aria-hidden');
          });

          video.addEventListener('blur', () => {
            videoContainer.setAttribute('aria-hidden', 'true');
          });
        }

        video.width = videoContainer.offsetWidth;
        video.height = videoContainer.offsetHeight;

        // Update player width on window resize
        window.addEventListener('resize', () => {
          video.width = videoContainer.offsetWidth;
          video.height = videoContainer.offsetHeight;
        });

      });
    }
  };

})(Drupal, window.Vimeo);
